module.exports = __webpack_public_path__ + "img/role_lmzt.5203dbf1.jpg";